import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';

interface SummaryProps {}

const SummaryPageTextBlock = () => {
  const idVerified = useSelector((state: RootState) => state.customer.customerDetails.isIdVerified);
  return (
    <div className="summary-text-block">
      <h4>Customer Disclosure and Consent</h4>
      <p>
        For details of how Payright will collect, hold and use your personal information, how your
        personal information will be disclosed to third parties (including credit agencies), how you
        can access or update personal information or make a complaint or enquiry relating to your
        personal information, please refer to the{' '}
        <a href="https://payright.com.au/privacy-policy/" target="_blank">
          Privacy Policy
        </a>
        .
      </p>
      <p>By submitting your plan application:</p>

      <ul className="policy">
        <div>
          <ul>
            <li>
              You acknowledge that you have read and agree to Payright’s{' '}
              <a href="https://payright.com.au/terms-and-conditions/" target="_blank">
                Account T&Cs
              </a>
            </li>
            <li>
              You acknowledge that you have read and agree to Payright’s{' '}
              <a href="https://payright.com.au/privacy-policy/" target="_blank">
                Privacy Policy
              </a>
            </li>
            <li>
              You consent to Payright conducting a credit check with a credit reporting body using
              your personal information for the purpose of processing your application. This credit
              check will create a visible record on your credit file.
            </li>
            {!idVerified && (
              <li>
                You consent to Payright conducting an electronic ID verification check using your
                personal information (being your full name, date of birth, residential address and
                drivers' licence number or passport number) for the purpose of processing your
                application. Your identity will be checked through third party sources which may
                include a credit reporting body. This will not create a record on your credit file.
                If Payright conducts an electronic ID verification check with a credit reporting
                body, Payright may request the credit reporting body to provide an assessment of
                whether your personal information matches personal information held by the credit
                reporting body. The credit reporting body may prepare and provide to Payright such
                an assessment and the credit reporting body may use your personal information, and
                personal information it holds relating to other individuals (such as their names,
                dates of birth, residential addresses, drivers licence and passport numbers) for the
                purpose of preparing such an assessment. If you do not consent to the electronic ID
                check, please cancel your application now and email manualid@payright.com.au to
                request instructions on how to complete your identity verification manually. With a
                manual verification process, Payright will require certified copies of your identity
                information which may cause delays in setting up your Payright account partly due to
                this application being cancelled and you needing to re-apply once we receive all the
                required documents.
              </li>
            )}
          </ul>
        </div>
      </ul>
    </div>
  );
};
export default SummaryPageTextBlock;
